import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "score.shortcuts.title",
    },
    p1: {
        id: "score.shortcuts.p1",
    },
    p2: {
        id: "score.shortcuts.p2",
    },
    pitch: {
        id: "score.shortcuts.pitch",
    },
    rhythm: {
        id: "score.shortcuts.rhythm",
    },
});

export default messages;
